import React from 'react';
import { Path } from 'react-native-svg';

import { IconBase, IconProps } from './IconBase';
import { SVG_PATH_TOAST_WARNING_TRIANGLE_WITH_EXCLAMATION } from './svgPaths';

export const IconToastWarning: React.FunctionComponent<IconProps> = (props) => (
  <IconBase viewBox="0 0 12 11" {...props}>
    <Path
      d={SVG_PATH_TOAST_WARNING_TRIANGLE_WITH_EXCLAMATION}
      fill="currentColor"
    />
  </IconBase>
);
